var _ellipse, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.6438,
    cy: 15.4938,
    rx: 14.987,
    ry: 14.9726,
    fill: "#F04C30"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_453_796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7038 15.4938H9.7636V13.1439C9.7636 11.8477 10.8184 10.794 12.1158 10.794H12.4098C12.8986 10.794 13.2919 10.4011 13.2919 9.91273V8.15034C13.2919 7.66201 12.8986 7.2691 12.4098 7.2691H12.1158C8.86684 7.2691 6.23535 9.89807 6.23535 13.1439V21.956C6.23535 22.9291 7.02553 23.7185 7.99948 23.7185H12.7038C13.6778 23.7185 14.4679 22.9291 14.4679 21.956V17.2562C14.4679 16.2832 13.6778 15.4938 12.7038 15.4938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2884 15.4938H20.3482V13.1439C20.3482 11.8477 21.403 10.794 22.7004 10.794H22.9944C23.4832 10.794 23.8764 10.4011 23.8764 9.91273V8.15034C23.8764 7.66201 23.4832 7.2691 22.9944 7.2691H22.7004C19.4514 7.2691 16.8199 9.89807 16.8199 13.1439V21.956C16.8199 22.9291 17.6101 23.7185 18.5841 23.7185H23.2884C24.2624 23.7185 25.0525 22.9291 25.0525 21.956V17.2562C25.0525 16.2832 24.2624 15.4938 23.2884 15.4938Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_453_796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.269,
    height: 19.2505,
    fill: "white",
    transform: "translate(6.0094 5.86853)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.8bede125cfed623fbe8ee189ec752b6b.svg";
export { ForwardRef as ReactComponent };